import { render, staticRenderFns } from "./student-attendance.vue?vue&type=template&id=ac53c1e4&scoped=true&"
import script from "./student-attendance.vue?vue&type=script&lang=js&"
export * from "./student-attendance.vue?vue&type=script&lang=js&"
import style0 from "./student-attendance.vue?vue&type=style&index=0&id=ac53c1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac53c1e4",
  null
  
)

export default component.exports